export interface SupportComposeHrefArgs {
  to: string;
  subject: string;
  /** Prompt shown to the user at the top of the body ("Please explain..."). */
  intro: string;
  /** Diagnostic lines appended under a header; an empty array omits the block. */
  diagnostics: string[];
}

/** Outlook web compose link. Not `mailto:` — on Windows it's easily bound to a browser and opens a blank tab. */
export const buildSupportComposeHref = ({ to, subject, intro, diagnostics }: SupportComposeHrefArgs): string => {
  const bodyLines = [intro, '', '', '---', 'Diagnostic info (do not edit):', ...diagnostics];
  // Not URLSearchParams: it encodes spaces as `+`, which Outlook shows literally.
  const query = [
    `to=${encodeURIComponent(to)}`,
    `subject=${encodeURIComponent(subject)}`,
    `body=${encodeURIComponent(bodyLines.join('\n'))}`,
  ].join('&');
  return `https://outlook.office.com/mail/deeplink/compose?${query}`;
};
